module.exports = __webpack_public_path__ + "img/just-in-time.616fe373.png";